import { syncConfigSentry } from "./syncConfigSentry.js";

function install(Vue, options = {}) {
  syncConfigSentry((Object && Object.keys(options).length > 0) ? options : undefined, Vue);
}

export { install };
